import * as admin from "firebase-admin";
import * as functions from "firebase-functions";

import Profile from "@sentrei/common/models/Profile";
import Username from "@sentrei/common/models/Username";

const db = admin.firestore();

/**
 * Update profile on create
 */
const profileUpdate = functions.firestore
  .document("usernames/{username}")
  .onCreate(snap => {
    const data = snap.data() as Username;
    return db
      .doc(`profiles/${data.uid}`)
      .update(<Profile.Update>{username: snap.id});
  });

export default profileUpdate;
